/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { OperatorDetailsDto } from '../api/operators/operatorsClient.typings';
import { Notification } from '../../utils/utils';
import {
    CashRegisterModelsListDto,
    OperatorCashRegisterModelsListFilterParams,
} from '../api/cashRegisterModels/cashRegisterModelsClient.typings';
import { PageQueryParams, SortQueryParams } from '../api/apiCommon.typings';
import { OperatorCashBoxesStats } from '../api/cashBoxes/cashBoxesClient.typings';

export enum OperatorDetailsActionType {
    OPEN_REGISTRY_OPERATOR_CARD_PAGE = 'RegistryOperatorCard/ open page',
    EXIT_REGISTRY_OPERATOR_CARD_PAGE = 'RegistryOperatorCard/ exit page',

    APPLY_CASH_REGISTERS_PAGING = 'RegistryOperatorCard/ apply cash registers paging',
    APPLY_CASH_REGISTERS_FILTER = 'RegistryOperatorCard/ apply cash registers filter',
    APPLY_CASH_REGISTERS_SORTING = 'RegistryOperatorCard/ apply cash regidters sorting',

    FETCH_OPERATOR_DETAILS_SUCCESS = 'RegistryOperatorCard/ fetch operator details success',
    FETCH_OPERATOR_CASHBOXES_STATS_SUCCESS = 'RegistryOperatorCard/ fetch operator cashboxes stats success',
    FETCH_OPERATOR_CASH_REGISTERS_SUCCESS = 'RegistryOperatorCard/ fetch operator cash registers success',

    FETCH_OPERATOR_CARD_DATA_ERROR = 'RegistryOperatorCard/ fetch operator card data error',
}

export const openRegistryOperatorCardAction = (taxNumber: string) =>
    createAction(OperatorDetailsActionType.OPEN_REGISTRY_OPERATOR_CARD_PAGE, taxNumber);

export const exitRegistryOperatorCardAction = () =>
    createAction(OperatorDetailsActionType.EXIT_REGISTRY_OPERATOR_CARD_PAGE);

export const applyCashRegistersPagingAction = (params: PageQueryParams) =>
    createAction(OperatorDetailsActionType.APPLY_CASH_REGISTERS_PAGING, params);

export const applyCashRegistersFilteringAction = (params: OperatorCashRegisterModelsListFilterParams) =>
    createAction(OperatorDetailsActionType.APPLY_CASH_REGISTERS_FILTER, params);

export const applyCashRegistersSortingAction = (params: SortQueryParams) =>
    createAction(OperatorDetailsActionType.APPLY_CASH_REGISTERS_SORTING, params);

export const fetchOperatorDetailsSuccessAction = (payload: OperatorDetailsDto) =>
    createAction(OperatorDetailsActionType.FETCH_OPERATOR_DETAILS_SUCCESS, payload);

export const fetchOperatorCashboxesStatsSuccessAction = (payload: OperatorCashBoxesStats) =>
    createAction(OperatorDetailsActionType.FETCH_OPERATOR_CASHBOXES_STATS_SUCCESS, payload);

export const fetchOperatorCashRegistersSuccessAction = (list: CashRegisterModelsListDto) =>
    createAction(OperatorDetailsActionType.FETCH_OPERATOR_CASH_REGISTERS_SUCCESS, list);

export const fetchOperatorCardDataErrorAction = (notification: Notification) =>
    createAction(OperatorDetailsActionType.FETCH_OPERATOR_CARD_DATA_ERROR, { notification });

export type OperatorDetailsActions =
    | ReturnType<typeof openRegistryOperatorCardAction>
    | ReturnType<typeof exitRegistryOperatorCardAction>
    | ReturnType<typeof applyCashRegistersPagingAction>
    | ReturnType<typeof applyCashRegistersFilteringAction>
    | ReturnType<typeof applyCashRegistersSortingAction>
    | ReturnType<typeof fetchOperatorDetailsSuccessAction>
    | ReturnType<typeof fetchOperatorCashboxesStatsSuccessAction>
    | ReturnType<typeof fetchOperatorCashRegistersSuccessAction>
    | ReturnType<typeof fetchOperatorCardDataErrorAction>;
